import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const IS_CACHE_ENABLED = new HttpContextToken<boolean>(() => false);
export const USE_CUSTOM_TOKEN = new HttpContextToken<string | null>(() => null);
export const LOCAL_STORAGE = new InjectionToken<Storage>('Local Storage');
